define('Components/PageHeaderWidget/js/views/PageHeaderAcquisitionView',['jquery',
    'app',
    'Components/PageHeaderWidget/js/views/PageHeaderWidgetInstanceView',
    'template!Components/PageHeaderWidget/templates/acquisition',
  ],
  function ($, app, PageHeaderWidgetInstanceView, PageHeaderAcqusitionTemplate) {
    return PageHeaderWidgetInstanceView.extend({
      getTemplate: function () {
        return PageHeaderAcqusitionTemplate
      }
    })
  });
